import { render, staticRenderFns } from "./CreateEditPlan.vue?vue&type=template&id=fa34c944&scoped=true"
import script from "./CreateEditPlan.vue?vue&type=script&lang=js"
export * from "./CreateEditPlan.vue?vue&type=script&lang=js"
import style0 from "./CreateEditPlan.vue?vue&type=style&index=0&id=fa34c944&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa34c944",
  null
  
)

export default component.exports